// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__13P5d","range":"MonthRangeSwitch_range__3cqCl","disabled":"MonthRangeSwitch_disabled__2Ll_Y"};